import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input, OnChanges, OnInit,
  Output, SimpleChanges,
  ViewChild
} from '@angular/core';
import {NgClass, NgForOf, NgIf} from '@angular/common';
import {HotelCellComponent} from '../hotel-cell/hotel-cell.component';
import {OfferCellComponent} from '../offer-cell/offer-cell.component';
import {Card, CardsArray} from '../../../model/cards';
import {ImageSliderComponent} from './image-slider/image-slider.component';
import {TextsComponent} from '../texts/texts.component';
import {Icons} from '../../../model/icon';

@Component({
  selector: 'app-horizontal-slider',
  imports: [
    NgForOf,
    NgClass,
    HotelCellComponent,
    NgIf,
    OfferCellComponent,
    ImageSliderComponent,
    TextsComponent,
    OfferCellComponent
  ],
  templateUrl: './horizontal-slider.component.html',
  standalone: true,
  styleUrl: './horizontal-slider.component.scss'
})
export class HorizontalSliderComponent implements OnInit, AfterViewInit, OnChanges {
  @Input() grid: number = 2;
  @Input() hotel: boolean = true;
  @Input() cards: Card[] = [];
  @Input() imagesCards: boolean = false;
  @Input() looped: boolean = false;
  @Input() soloSlide: boolean = false;
  @Input() cardsLength: boolean = false;
  @Input() firstArray: boolean = true;

  @Output() clickOn = new EventEmitter();
  @Output() positionChanged = new EventEmitter();

  @ViewChild('container', { static: false }) container!: ElementRef;
  @ViewChild('slider', { static: true }) slider!: ElementRef<HTMLDivElement>;

  private isDragging: boolean = false;
  private startX: number = 0;
  private startY: number = 0;
  private scrollLeft: number = 0;
  private offScrollBehavior: boolean = false;
  private isHorizontalScroll: boolean = false;

  items: any[] = [];

  startingX: number = 0;
  startingY: number = 0;
  cardsArray: Card[] = []

  activeNumber: number = 0

  tab: boolean = false;
  isMobile: boolean = false;
  firstShortSlide: boolean = false;

  containerWidth: number = 0;

  ngAfterViewInit() {
    this.containerWidth = this.container?.nativeElement.children[0].offsetWidth;
    setTimeout(() => this.checkPosition(), 0);
  }

  ngOnInit() {
    this.items = this.cards.slice();
    this.cardsArray = this.cards;
    if (window.innerWidth <= 769) {
      this.tab = true;
      if (window.innerWidth <= 571) {
        this.isMobile = true;
        if (!this.hotel && !this.imagesCards) {
          this.firstShortSlide = true;
        }
      }
    }
  }

  getCards() {
    return this.items;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['cards']) {
      this.cardsArray = this.cards;
      this.items = this.cards.slice();
    }
  }

  @HostListener('mousedown', ['$event'])
  onMouseDown(event: MouseEvent) {
    event.preventDefault();
    this.offScrollBehavior = true;
    this.isDragging = true;
    this.isHorizontalScroll = false;
    this.startX = event.pageX - this.slider.nativeElement.offsetLeft;
    this.scrollLeft = this.slider.nativeElement.scrollLeft;
    setTimeout(() => {
      this.checkPosition();
    },500);
  }

  @HostListener('touchstart', ['$event'])
  onTouchStart(event: TouchEvent) {
    this.startingX = event.touches[0].clientX;
    this.startingY = event.touches[0].clientY;
    this.offScrollBehavior = true;
    this.isDragging = true;
    this.isHorizontalScroll = false;
    this.startX = event.touches[0].pageX - this.slider.nativeElement.offsetLeft;
    this.startY = event.touches[0].pageY - this.slider.nativeElement.offsetLeft;
    this.scrollLeft = this.slider.nativeElement.scrollLeft;
    setTimeout(() => {
      this.checkPosition();
    },500);
  }

  @HostListener('mousemove', ['$event'])
  onMouseMove(event: MouseEvent) {
    if (!this.isDragging) return;
    event.preventDefault();
    const x = event.pageX - this.slider.nativeElement.offsetLeft;
    const walk = (x - this.startX);
    this.slider.nativeElement.scrollLeft = this.scrollLeft - walk;
    this.isHorizontalScroll = true;
    setTimeout(() => {
      this.checkPosition();
    },500);
  }

  @HostListener('touchmove', ['$event'])
  onTouchMove(event: TouchEvent) {
    if (!this.isDragging) return;
    const deltaX = event.touches[0].clientX - this.startingX;
    const deltaY = event.touches[0].clientY - this.startingY;
    if (Math.abs(deltaX) > Math.abs(deltaY)) {
      event.preventDefault();
      this.isHorizontalScroll = true;
      const x = event.touches[0].pageX - this.slider.nativeElement.offsetLeft;
      const walk = (x - this.startX);
      this.slider.nativeElement.scrollLeft = this.scrollLeft - walk;
    } else {
      this.isHorizontalScroll = false;
    }
    setTimeout(() => {
      this.checkPosition();
    },500);
  }

  @HostListener('wheel', ['$event'])
  onWheel(event: WheelEvent) {
    if (Math.abs(event.deltaX) > Math.abs(event.deltaY)) {
      event.preventDefault();
    }
  }

  @HostListener('mouseup')
  onMouseUp() {
    this.offScrollBehavior = false;
    setTimeout(() => {
      this.isDragging = false;
      this.scrollToNearest();
    }, 50);
    setTimeout(() => {
      this.checkPosition();
    },500);
  }

  @HostListener('touchend')
  onTouchEnd() {
    this.offScrollBehavior = false;
    setTimeout(() => {
      this.isDragging = false;
      this.scrollToNearest();
    }, 50);
    setTimeout(() => {
      this.checkPosition();
    },500);
  }

  @HostListener('mouseleave')
  onMouseLeave() {
    this.offScrollBehavior = false;
    setTimeout(() => {
      this.isDragging = false;
      this.scrollToNearest();
    }, 50);
    setTimeout(() => {
      this.checkPosition();
    },500);
  }

  getCurrentVisibleSlideIndex(): number {
    if (!this.slider?.nativeElement) return 0;
    const slider = this.slider.nativeElement;
    const slideWidth = slider.clientWidth;
    const scrollPosition = slider.scrollLeft;
    const currentIndex = Math.round(scrollPosition / slideWidth);
    return Math.min(Math.max(currentIndex, 0), this.items.length - 1);
  }

  turnLeft() {
    this.slider.nativeElement.scrollLeft -= this.containerWidth / this.grid;
    setTimeout(() => this.checkPosition(), 500);
  }

  turnRight() {
    this.slider.nativeElement.scrollLeft += this.containerWidth / this.grid;
    setTimeout(() => this.checkPosition(), 500);
  }

  checkPosition() {
    const slider = this.slider.nativeElement;
    const isAtStart = slider.scrollLeft <= 0;
    const isAtEnd = slider.scrollLeft + slider.clientWidth >= slider.scrollWidth - 1;
    this.activeNumber = this.getCurrentVisibleSlideIndex();
    this.positionChanged.emit({ isAtStart, isAtEnd });
  }

  scrollToNearest() {
    const sl = this.slider.nativeElement.scrollLeft;
    const we = this.containerWidth / this.grid;
    const isMobile = window.innerWidth <= 769;
    let threshold = isMobile ? we * 0.2 : we * 0.5;
    if (this.firstShortSlide && isMobile) {
      threshold = threshold * 0.95;
    }
    const x = sl % we;
    const y = x > threshold;
    const u = Math.floor(sl / we) * we;
    const z = Math.ceil(sl / we);
    let scrollLeft = y ? u + we : u;
    if (this.firstShortSlide) {
      scrollLeft -= we * 0.05;
    }
    this.slider.nativeElement.scrollLeft = scrollLeft;
    setTimeout(() => this.checkPosition(), 100);
  }


  sliderClass(){
    return !this.offScrollBehavior ? 'slider-scroll-behavior' : '';
  }

  slideStyle(idx: number) {
    if (this.firstShortSlide && idx === 0) {
      return `min-width: calc(${(95 / this.grid)}%); max-width: calc(${(95 / this.grid)}%);`
    } else {
      return `min-width: calc(${(100 / this.grid)}%); max-width: calc(${(100 / this.grid)}%);`
    }
  }

  emitClick(bool: boolean) {
    this.clickOn.emit(bool);
  }

  protected readonly CardsArray = CardsArray;
  protected readonly Icons = Icons;
}
